/*
 * Copyright (c) 2023-2024. Haodong JU
 */

import { addDoc, collection, deleteDoc, doc, query, where } from 'firebase/firestore'
import { FireBaseStore } from '@/model/firebase/google-fire-base'
import { getCurrentUserId } from '@/model/dataLayer/api/SaaS/user'
import { resultOf, resultOfId } from '@/model/firebase/queryUtils'
import hillo from 'hillo'

const userAndStoreRelation = 'userStore'

export async function findDeviceByDeviceId (deviceId) {
  try {
    return (await hillo.jsonPost(cloudUrl + '/virtualDevice/search', { deviceId })).data?.[0]
  } catch (e) {
    console.log(e)
    return null
  }
}

export async function createUserRelationShip (deviceId) {
  const userId = getCurrentUserId()
  const currentList = await getAllStoreIdForUser()
  if (currentList.includes(deviceId)) {
    return
  }
  return await addDoc(collection(FireBaseStore, userAndStoreRelation), {
    userId,
    deviceId
  })
}

export async function getAllStoreIdForUser () {
  const res = query(collection(FireBaseStore,
    userAndStoreRelation),
  where('userId', '==', getCurrentUserId()))
  return (await resultOf(res)).map(it => it.deviceId)
}

export async function getUserAndStoreRelationByDeviceId (deviceId) {
  const res = query(collection(FireBaseStore,
    userAndStoreRelation),
  where('deviceId', '==', deviceId))
  return (await resultOf(res))[0]
}

export async function getAllStoreInfoForUser () {
  const res = query(collection(FireBaseStore,
    userAndStoreRelation),
  where('userId', '==', getCurrentUserId()))
  return (await resultOfId(res))
}

export async function deleteSelectedStore (firebaseId) {
  return await deleteDoc(doc(FireBaseStore, userAndStoreRelation, firebaseId))
}

export const cloudUrl = 'https://cloud5.api.aaden.io'
